import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { take } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../service/auth.service';

import { Patient } from '../patient';
import { PatientService } from '../../service/patient.service';

@Component({
  selector: 'mc-patient-new',
  templateUrl: './patient-new.component.html',
  styleUrls: ['./patient-new.component.scss']
})
export class PatientNewComponent implements OnInit {

  patient: Patient;

  constructor(
    private patientService: PatientService,
    private router: Router,
    private location: Location,
    private notifService: ToastrService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.patient = new Patient();
    let today = new Date();
    // @ts-ignore
    this.patient.dob = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
  }

  savePatient(): void {
    if (this.patient) {
      this.patientService.createPatient(this.patient).subscribe(
        patient => {
          this.patient = patient;
          if (this.authService.isDoctor()) {
            this.notifService.success('Clique aqui para iniciar o atendimento', 'Paciente adicionado')
              .onTap
              .pipe(take(1))
              .subscribe(() => this.router.navigate([`paciente/${this.patient.id}/atendimento/novo`]));
          } else {
            this.notifService.success('Paciente adicionado');
          }
          this.location.back();
        },
        error => this.notifService.error(error)
      );
    }
  }

  goBack(): void {
    this.location.back();
  }
}
